export enum TelegramEventEnum {
    AccelerometerChanged = 'accelerometer_changed',
    AccelerometerFailed = 'accelerometer_failed',
    AccelerometerStarted = 'accelerometer_started',
    AccelerometerStopped = 'accelerometer_stopped',
    BackButtonPressed = 'back_button_pressed',
    BiometryAuthRequested = 'biometry_auth_requested',
    BiometryInfoReceived = 'biometry_info_received',
    BiometryTokenUpdated = 'biometry_token_updated',
    ClipboardTextReceived = 'clipboard_text_received',
    ContentSafeAreaChanged = 'content_safe_area_changed',
    CustomMethodInvoked = 'custom_method_invoked',
    DeviceOrientationChanged = 'device_orientation_changed',
    DeviceOrientationFailed = 'device_orientation_failed',
    DeviceOrientationStarted = 'device_orientation_started',
    DeviceOrientationStopped = 'device_orientation_stopped',
    EmojiStatusAccessRequested = 'emoji_status_access_requested',
    EmojiStatusFailed = 'emoji_status_failed',
    EmojiStatusSet = 'emoji_status_set',
    FileDownloadRequested = 'file_download_requested',
    FullscreenChanged = 'fullscreen_changed',
    FullscreenFailed = 'fullscreen_failed',
    GyroscopeChanged = 'gyroscope_changed',
    GyroscopeFailed = 'gyroscope_failed',
    GyroscopeStarted = 'gyroscope_started',
    GyroscopeStopped = 'gyroscope_stopped',
    HomeScreenAdded = 'home_screen_added',
    HomeScreenChecked = 'home_screen_checked',
    HomeScreenFailed = 'home_screen_failed',
    InvoiceClosed = 'invoice_closed',
    LocationChecked = 'location_checked',
    LocationRequested = 'location_requested',
    MainButtonPressed = 'main_button_pressed',
    PhoneRequested = 'phone_requested',
    PopupClosed = 'popup_closed',
    PreparedMessageFailed = 'prepared_message_failed',
    PreparedMessageSent = 'prepared_message_sent',
    QrTextReceived = 'qr_text_received',
    ReloadIframe = 'reload_iframe',
    SafeAreaChanged = 'safe_area_changed',
    ScanQrPopupClosed = 'scan_qr_popup_closed',
    SecondaryButtonPressed = 'secondary_button_pressed',
    SetCustomStyle = 'set_custom_style',
    SettingsButtonPressed = 'settings_button_pressed',
    ThemeChanged = 'theme_changed',
    ViewportChanged = 'viewport_changed',
    VisibilityChanged = 'visibility_changed',
    WriteAccessRequested = 'write_access_requested',
}
